import { Routes, Route } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import RecruitList from './common/RecruitList';
import RecruitDetail from './common/RecruitDetail';
import RecruitSimplePost from './common/RecruitSimplePost';
import RecruitLanding from './common/RecruitLanding';
import RecruitMinisterPost from './recruit_minister/RecruitMinisterPost';
import RecruitOverseasPost from './recruit_overseas/RecruitOverseasPost';
import { AggregatedClaimPage, AggregatedClaimVerifyPage, AggregatedDeleteConfirmPage } from './claim/AggregatedClaim';
import {
  MINISTER_RECRUIT_CONFIG,
  OVERSEAS_RECRUIT_CONFIG,
  CHURCH_RECRUIT_CONFIG,
  INSTITUTE_RECRUIT_CONFIG,
} from './common/recruitConfigs';

export default function RecruitRouter() {
  return (
    <div>
      <Header />
      {/* 게시판들이 같은 컴포넌트(RecruitList 등)를 공유하므로, 메뉴로 게시판을 바꿀 때
          이전 게시판의 목록·페이지 상태가 남지 않도록 경로별 key로 새로 마운트한다 */}
      <Routes>
        <Route path="/" element={<RecruitList key="/" config={MINISTER_RECRUIT_CONFIG} />} />
        {/* 공고 상세 (검색엔진용 고유 URL — 서버가 메타·JSON-LD를 주입해 응답) */}
        <Route path="/minister/:id" element={<RecruitDetail key="/minister" config={MINISTER_RECRUIT_CONFIG} />} />
        <Route path="/overseas/:id" element={<RecruitDetail key="/overseas" config={OVERSEAS_RECRUIT_CONFIG} />} />
        <Route path="/church/:id" element={<RecruitDetail key="/church" config={CHURCH_RECRUIT_CONFIG} />} />
        <Route path="/institute/:id" element={<RecruitDetail key="/institute" config={INSTITUTE_RECRUIT_CONFIG} />} />
        {/* 가져온 공고 인수(선점) · 삭제 요청 (aggregated-posting-lock-design.md 5장 — 서버가 noindex) */}
        <Route path="/claim/verify" element={<AggregatedClaimVerifyPage />} />
        <Route path="/claim/delete-confirm" element={<AggregatedDeleteConfirmPage />} />
        <Route path="/claim/:kind/:id" element={<AggregatedClaimPage />} />
        {/* 지역 × 직분 랜딩 (검색 유입용) */}
        <Route path="/area/:region" element={<RecruitLanding />} />
        <Route path="/area/:region/:position" element={<RecruitLanding />} />
        {/* 예전 ?id= 상세 경로 호환 (스크랩·외부 링크) */}
        <Route path="/recruitministerdetail" element={<RecruitDetail key="/recruitministerdetail" config={MINISTER_RECRUIT_CONFIG} />} />
        <Route path="/recruitministerpost" element={<RecruitMinisterPost key="/recruitministerpost" />} />

        <Route path="/recruitoverseaslist" element={<RecruitList key="/recruitoverseaslist" config={OVERSEAS_RECRUIT_CONFIG} />} />
        <Route path="/recruitoverseasdetail" element={<RecruitDetail key="/recruitoverseasdetail" config={OVERSEAS_RECRUIT_CONFIG} />} />
        <Route path="/recruitoverseaspost" element={<RecruitOverseasPost key="/recruitoverseaspost" />} />

        <Route path="/recruitchurchlist" element={<RecruitList key="/recruitchurchlist" config={CHURCH_RECRUIT_CONFIG} />} />
        <Route path="/recruitchurchdetail" element={<RecruitDetail key="/recruitchurchdetail" config={CHURCH_RECRUIT_CONFIG} />} />
        {/* 예전 스크랩 데이터에 저장된 잘못된 경로 호환 */}
        <Route path="/recruitchoirdetail" element={<RecruitDetail key="/recruitchoirdetail" config={CHURCH_RECRUIT_CONFIG} />} />
        <Route path="/recruitchurchpost" element={<RecruitSimplePost key="/recruitchurchpost" config={CHURCH_RECRUIT_CONFIG} />} />

        <Route path="/recruitinstitutelist" element={<RecruitList key="/recruitinstitutelist" config={INSTITUTE_RECRUIT_CONFIG} />} />
        <Route path="/recruitinstitutedetail" element={<RecruitDetail key="/recruitinstitutedetail" config={INSTITUTE_RECRUIT_CONFIG} />} />
        <Route path="/recruitinstitutepost" element={<RecruitSimplePost key="/recruitinstitutepost" config={INSTITUTE_RECRUIT_CONFIG} />} />
      </Routes>
      <Footer />
    </div>
  );
}
